import React from 'react';
import CheckMark from '../../../assets/images/v-mark-studio.svg';
import { Box, Heading, Text } from '@wix/design-system';
import { useTranslation } from 'react-i18next';
import s from './AllPlansInclude.scss';
import { RootStore, withInjectedRootStore } from 'providers';
import { RealEstateId } from 'enums';
import { ItemIncludeInAllPlans, JsonMap } from 'types';

const AllPlansIncludeComponent: React.FC<{ rootStore: RootStore }> = ({
  rootStore,
}) => {
  const { parsedDealerOffers } = rootStore.appStore.appContext;
  const offeringAllPlansIncludeItems: JsonMap<any> = parsedDealerOffers.get(
    RealEstateId.WixStudioAllPlansInclude,
  );
  const { t } = useTranslation();

  if (
    !offeringAllPlansIncludeItems ||
    !Object.values(offeringAllPlansIncludeItems).length
  ) {
    return <></>;
  }

  const itemsToRender: ItemIncludeInAllPlans[] = Object.values(
    offeringAllPlansIncludeItems,
  )
    .filter((item) => item?.order)
    .sort((a, b) => a?.order - b?.order);

  return (
    <Box
      direction='horizontal'
      width='100%'
      padding='126px 48px'
      boxSizing='border-box'
      align='space-between'
      gap='36px'
      className={s.wixStudioBackgroundColor}
    >
      <Box maxWidth='254px' minWidth='236px'>
        <Heading light appearance='H2' className={s.semiBold}>
          {t('studio_package_picker.banner.all_plans_include.title')}
        </Heading>
      </Box>
      <Box gap='24px'>
        <Box direction='vertical' minWidth='324px' maxWidth='380px'>
          {itemsToRender
            ?.slice(0, 4)
            .map(({ featureTitleTranslationKey, order }) => (
              <Box
                marginBottom='30px'
                verticalAlign='top'
                maxWidth='max-content'
                gap='SP1'
                key={order}
              >
                <Box paddingTop='8px'>
                  <CheckMark />
                </Box>
                <Text light className={s.bolder}>
                  {t(featureTitleTranslationKey)}
                </Text>
              </Box>
            ))}
        </Box>
        <Box direction='vertical' minWidth='324px' maxWidth='380px'>
          {itemsToRender
            ?.slice(4)
            .map(({ featureTitleTranslationKey, order }) => (
              <Box
                marginBottom='30px'
                verticalAlign='top'
                maxWidth='max-content'
                gap='SP1'
                key={order}
              >
                <Box paddingTop='8px'>
                  <CheckMark />
                </Box>
                <Text light className={s.bolder}>
                  {t(featureTitleTranslationKey)}
                </Text>
              </Box>
            ))}
        </Box>
      </Box>
    </Box>
  );
};

export const AllPlansInclude = withInjectedRootStore(AllPlansIncludeComponent);
